import { A7LayoutModule } from '@ark7/layout';
import { A7LoadingModule } from '@ark7/loading';
import { A7MovingNumberModule } from '@ark7/moving-number';
import { A7PanelModule } from '@ark7/panel';
import { A7ResourcesCommonModule } from '@ark7/resources-common';
import { A7TooltipsModule } from '@ark7/tooltips';
import { A7UtilsModule } from '@ark7/utils';
import { CommonModule } from '@angular/common';
import {
  FaIconLibrary,
  FontAwesomeModule,
} from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faLink } from '@fortawesome/free-solid-svg-icons/faLink';
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faFacebookMessenger } from '@fortawesome/free-brands-svg-icons/faFacebookMessenger';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/faQuestionCircle';

import {
  A7DialogBaseActionsDirective,
  A7DialogBaseContentsDirective,
  DialogBaseComponent,
} from './dialog-base/dialog-base.component';
import { A7LabelValueComponent } from './label-value/label-value.component';
import { A7SpjTemplateDirective } from './a7-switch-panel-junior/a7-spj-template.directive';
import { A7SwitchPanelJuniorComponent } from './a7-switch-panel-junior/a7-switch-panel-junior.component';
import { AppSectionComponent } from './app-section/app-section.component';
import { CarouselComponent } from './carousel/carousel.component';
import {
  CarouselItemDirective,
  CarouselItemElement,
} from './carousel/carousel-item.directive';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { CloseButtonComponent } from './close-button/close-button.component';
import { FootDropComponent } from './footer/foot-drop/foot-drop.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HoverClassDirective } from './hover-class.directive';
import { InplaceDropdownSelectComponent } from './inplace-dropdown-select/inplace-dropdown-select.component';
import { LogoComponent } from './logo/logo.component';
import { MatMenuComponent } from './mat-menu/mat-menu.component';
import { MatMenuTemplateDirective } from './mat-menu/mat-menu-template.directive';
import { PageIndexComponent } from './page-index/page-index.component';
import { ShareFooterComponent } from './share-footer/share-footer.component';
import { SocialShareComponent } from './social-share/social-share.component';
import { TwoColumnsPageComponent } from './two-columns-page/two-columns-page.component';
import { V2DialogBarComponent } from './v2-dialog-bar/v2-dialog-bar.component';
import { VisualSlideComponent } from './visual-slide/visual-slide.component';

/**
 * Shared components that do NOT pull in google-maps / ng-animate. Carrier and
 * location components live in `@ark7/carrier-components`.
 */
@NgModule({
  declarations: [
    A7DialogBaseActionsDirective,
    A7DialogBaseContentsDirective,
    A7SpjTemplateDirective,
    A7SwitchPanelJuniorComponent,
    AppSectionComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    ChatbotComponent,
    CloseButtonComponent,
    DialogBaseComponent,
    FootDropComponent,
    FooterComponent,
    HeaderComponent,
    HoverClassDirective,
    InplaceDropdownSelectComponent,
    LogoComponent,
    MatMenuComponent,
    MatMenuTemplateDirective,
    PageIndexComponent,
    ShareFooterComponent,
    SocialShareComponent,
    TwoColumnsPageComponent,
    V2DialogBarComponent,
    VisualSlideComponent,
    A7LabelValueComponent,
  ],
  imports: [
    A7LayoutModule,
    A7LoadingModule,
    A7MovingNumberModule,
    A7PanelModule,
    A7ResourcesCommonModule,
    A7TooltipsModule,
    A7UtilsModule,
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    MatDialogModule,
    MatExpansionModule,
    MatMenuModule,
    RouterModule,
    ShareButtonsModule,
  ],
  exports: [
    A7DialogBaseActionsDirective,
    A7DialogBaseContentsDirective,
    A7SpjTemplateDirective,
    A7SwitchPanelJuniorComponent,
    AppSectionComponent,
    CarouselComponent,
    CarouselItemDirective,
    CarouselItemElement,
    ChatbotComponent,
    CloseButtonComponent,
    DialogBaseComponent,
    FootDropComponent,
    FooterComponent,
    HeaderComponent,
    HoverClassDirective,
    InplaceDropdownSelectComponent,
    LogoComponent,
    MatMenuComponent,
    MatMenuTemplateDirective,
    PageIndexComponent,
    ShareFooterComponent,
    SocialShareComponent,
    TwoColumnsPageComponent,
    V2DialogBarComponent,
    VisualSlideComponent,
    A7LabelValueComponent,
  ],
})
export class A7SharedComponentsModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faLink,
      faQuestionCircle,
      faEnvelope,
      faWhatsapp,
      faFacebookF,
      faFacebookMessenger,
      faTwitter,
    );
  }
}
